import { TextChip } from '@shared/components';
import { AssigneeOptionVariant } from '@shared/components/dropdown-chip/DropdownChip';
import { formatOption } from 'clerk_common/stringification/options';
import { CoverageStatus } from 'clerk_common/types/voomaFreight/contractedMovement';
import { ReactElement } from 'react';

const COVERAGE_STATUS_VARIANTS: Record<CoverageStatus, AssigneeOptionVariant> =
  {
    [CoverageStatus.AVAILABLE]: AssigneeOptionVariant.INFO,
    [CoverageStatus.CREATED]: AssigneeOptionVariant.DEFAULT,
    [CoverageStatus.COVERED]: AssigneeOptionVariant.SUCCESS,
    [CoverageStatus.DELIVERED]: AssigneeOptionVariant.SUCCESS,
    [CoverageStatus.DISPATCHED]: AssigneeOptionVariant.SUCCESS,
    [CoverageStatus.LOADED]: AssigneeOptionVariant.SUCCESS,
    [CoverageStatus.RELEASED_TO_BILLING]: AssigneeOptionVariant.SUCCESS,
    [CoverageStatus.TENDER_ACCEPTED]: AssigneeOptionVariant.WARNING,
    [CoverageStatus.TENDER_OFFERED]: AssigneeOptionVariant.WARNING,
    [CoverageStatus.TENDERED]: AssigneeOptionVariant.WARNING,
    [CoverageStatus.UNKNOWN]: AssigneeOptionVariant.DEFAULT,
    [CoverageStatus.UNLOADED]: AssigneeOptionVariant.SUCCESS,
    [CoverageStatus.VOIDED]: AssigneeOptionVariant.DANGER,
  };

export function getCoverageStatusLabel(status: CoverageStatus): string {
  return status === CoverageStatus.AVAILABLE ? 'Open' : formatOption(status);
}

export function CoverageStatusChip({
  status,
}: {
  status: CoverageStatus;
}): ReactElement {
  return (
    <TextChip
      text={getCoverageStatusLabel(status)}
      variant={COVERAGE_STATUS_VARIANTS[status]}
      shouldCapitalize={false}
    />
  );
}
